import { Grid, Typography } from "@mui/material";
import { HardwareType } from "../../api/api-generated";
import { useFindAllTypeLinksForUserQuery } from "../../api/api-hooks";
import LinkNewTab from "../../components/LinkNewTab";

interface Props {
  hardwareType: HardwareType;
}

const HardwareDocumentationDisplay = ({ hardwareType }: Props) => {
  const { data: allLinks } = useFindAllTypeLinksForUserQuery({});
  if (allLinks === undefined) return null;
  const filteredLinks = allLinks.filter(
    (link) => link.hardwareTypeId === hardwareType.id
  );
  return (
    <Grid
      item
      container
      direction="column"
      alignItems="flex-start"
      spacing={2}
      sm
    >
      <Grid item>
        <Typography variant="h5">Documentation</Typography>
      </Grid>
      {filteredLinks.map((link) => (
        <Grid item>
          <LinkNewTab href={link.link} label={link.name} />
        </Grid>
      ))}
    </Grid>
  );
};

export default HardwareDocumentationDisplay;
